<script>
import { layoutComputed } from "@/state/helpers";
import Button from "@/components/button";

export default {
  props: {},
  components: {Button},
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    go_print(){
      window.print();
    }
  },
  mounted() {},
};
</script>

<template>
  <div class="row">
    <div class="row print-hide" style="padding:1cm">
      <div class="col-sm-10"></div>
      <div class="col-sm-2 print">
          <Button :icon="'bx bx-printer'" 
            :buttonType="'button'"
            @click="go_print();"
            :titleLocate="'general.print'" />
      </div>
    </div>
    <slot />
  </div>
</template>